import objectAssignDeep from 'object-assign-deep'
import { decorators } from '@sohohouse/platform-resources'
import { getChangedAttributes, joinArrayBySeparator, transformObjectByKeys } from '~/helpers'
import { defaultState, sharedFilters } from '../constants'

const { DateTime } = decorators.shared

const getFilters = (filters, eventView) => {
  if (filters[eventView]) {
    const shared = sharedFilters.reduce((acc, filter) => ({
      ...acc,
      [filter]: filters[filter]
    }), {})
    return {
      ...filters[eventView],
      ...shared
    }
  }
  return {}
}

const emptyFilters = eventView => getFilters(defaultState.filters, eventView)

export default {
  eventViewFilters: s => eventView => getFilters(s.filters, eventView),

  defaultFilters: (_, getters, globalState, globalGetters) => eventView => {
    const houses = globalGetters['user/account/favoriteVenues'].map(house => house.id)
    const houseWithActiveParents = houses.reduce((venues, id) => [
      ...venues,
      ...globalGetters['venues/activeVenuesByParentId'](id)
    ], [])

    if (eventView === 'visits') {
      return {
        ...emptyFilters(eventView)
      }
    }
    return {
      ...emptyFilters(eventView),
      houses: houses.concat(houseWithActiveParents)
    }
  },

  changedFilters: (_, getters) => eventView => getChangedAttributes(
    getters.eventViewFilters(eventView),
    getters.defaultFilters(eventView)
  ),

  apiReadyEventViewFilters: (_, getters) => eventView => {
    const updatedFilters = getChangedAttributes(
      getters.eventViewFilters(eventView),
      emptyFilters(eventView)
    )

    // Persist requested types across requests
    updatedFilters.types = getters.eventViewFilters(eventView).types

    const apiFilter = transformObjectByKeys(updatedFilters, {
      categories: categories => ({ category: joinArrayBySeparator(categories) }),
      houses: houses => ({ parentLocationId: joinArrayBySeparator(houses) }),
      types: types => ({ type: joinArrayBySeparator(types) }),
      fromDate: (from, { venueDate }) => ({
        venueDate: {
          ...venueDate,
          from: new DateTime(from).isoShortString
        }
      }),
      toDate: (to, { venueDate }) => ({
        venueDate: {
          ...venueDate,
          to: new DateTime(to).isoShortString
        }
      })
    })

    return { filter: apiFilter }
  },

  queryStringFilters: (_, getters) => eventView => {
    const qsFilters = getters.changedFilters(eventView)

    const query = Object.entries(qsFilters).reduce(
      (acc, [key, val]) => ({
        ...acc,
        [key]: joinArrayBySeparator(val)
      }),
      {}
    )

    return query
  },

  applyEventViewFilters: (_, getters) => ({ eventView, params }) => {
    const eventViewFilters = getters.apiReadyEventViewFilters(eventView)

    return objectAssignDeep({}, eventViewFilters, params)
  },

  areFiltersApplied: (_, getters) => eventView => {
    const changedFilters = getters.changedFilters(eventView)
    return Object.keys(changedFilters).length > 0
  }
}
